const langtrans={
      fhssyy:["返回上一页","Back"],
      jyqq:["救援请求","Request for services"],
      ajxsxx:["案件信息","Case info."],
      jyqqfj:["救援请求附件","Request attachment"],
      jyffwq:["救援服务清单","Service list"],
      hfbjjj:["回复报价及方案","Reply to plan and quotation"],
      gbxqq:["关闭详情","Details closeds"],
      rdajjq:["如对案件及清单有疑问，可与江泰指挥中心联系","Please contact Jiang Tai Command Center if you have questions regarding the case and service list."],
      lxjdh:["联系电话：","Contact no."],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/par.vue.trans.js